/* Page Recettes : filtre salé / sucré + fiche recette interactive.
   Le contenu ci-dessous est volontairement vide : il sera rempli avec les vraies recettes.
   Chaque recette : { name, cat, img, tagline, time, servings, level, ingredients: [], steps: [[titre, texte]] } */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dataEl = document.querySelector('[data-recipes]');
  var RECIPES = {};
  try { RECIPES = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { RECIPES = {}; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* filtre */
  var chips = $$('.chip'), cards = $$('.card');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-filter');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      cards.forEach(function (card) {
        var show = f === 'all' || card.getAttribute('data-cat') === f;
        card.hidden = !show; card.classList.remove('is-in');
        if (show) { void card.offsetWidth; card.classList.add('is-in'); }
      });
    });
  });

  /* fiche */
  var dlg = $('#dlg');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var steps = [], cur = 0, opener = null;
  var bar = $('#dlg-bar'), count = $('#dlg-count'), prev = $('#dlg-prev'), next = $('#dlg-next');

  function render() {
    steps.forEach(function (li, i) {
      li.classList.toggle('is-cur', i === cur);
      li.classList.toggle('is-done', i < cur);
    });
    bar.style.width = steps.length ? ((cur + 1) / steps.length * 100) + '%' : '0';
    count.textContent = 'Étape ' + (cur + 1) + ' / ' + steps.length;
    prev.disabled = cur === 0;
    next.disabled = cur === steps.length - 1;
    next.querySelector ? null : null;
    next.textContent = cur === steps.length - 2 ? 'Dernière étape' : 'Étape suivante';
  }
  function go(i) {
    cur = Math.max(0, Math.min(steps.length - 1, i)); render();
    if (steps[cur].scrollIntoView) steps[cur].scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }

  function fill(id) {
    var r = RECIPES[id]; if (!r) return;
    $('#dlg-img').src = r.img;
    $('#dlg-cat').textContent = r.cat === 'sucre' ? 'Sucré' : 'Salé';
    $('#dlg-name').textContent = r.name;
    $('#dlg-tag').textContent = r.tagline;
    var meta = $('#dlg-meta'); meta.innerHTML = '';
    [r.time, r.servings, r.level].forEach(function (m) { if (m) { var li = document.createElement('li'); li.textContent = m; meta.appendChild(li); } });

    var ul = $('#dlg-ings'); ul.innerHTML = '';
    (r.ingredients || []).forEach(function (t) {
      var li = document.createElement('li'), lab = document.createElement('label');
      lab.innerHTML = '<input type="checkbox"><span class="box" aria-hidden="true"></span><span class="txt"></span>';
      lab.querySelector('.txt').textContent = t; li.appendChild(lab); ul.appendChild(li);
    });
    var ck = $$('input', ul), c = $('#dlg-ing-count');
    function upd() { c.textContent = ck.filter(function (x) { return x.checked; }).length + ' / ' + ck.length; }
    ck.forEach(function (x) { x.addEventListener('change', upd); }); upd();

    var ol = $('#dlg-steps'); ol.innerHTML = '';
    (r.steps || []).forEach(function (s, i) {
      var li = document.createElement('li');
      li.innerHTML = '<h4></h4><p></p>'; li.querySelector('h4').textContent = s[0] || ('Étape ' + (i + 1)); li.querySelector('p').textContent = s[1];
      li.addEventListener('click', function () { go(i); });
      ol.appendChild(li);
    });
    steps = $$('li', ol); cur = 0; render();
  }

  var lockY = 0;
  function lockScroll() {
    lockY = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.classList.add('has-dlg');
    document.body.style.top = (-lockY) + 'px';
  }
  function unlockScroll() {
    document.documentElement.classList.remove('has-dlg');
    document.body.style.top = '';
    window.scrollTo(0, lockY);
  }

  function open(id, from) {
    fill(id); opener = from || null; lockScroll(); dlg.showModal();
    var b = $('.dlg__body', dlg); if (b) b.scrollTop = 0;
    var din = $('.dlg__in', dlg); if (din) din.scrollTop = 0;
    history.replaceState(null, '', '#' + id);
  }
  cards.forEach(function (card) {
    var b = $('[data-open]', card);
    b.addEventListener('click', function () { open(b.getAttribute('data-open'), b); });
  });
  prev.addEventListener('click', function () { go(cur - 1); });
  next.addEventListener('click', function () { go(cur + 1); });
  $('[data-close]', dlg).addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('keydown', function (e) {
    if (e.target.closest('input, button')) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowUp') { e.preventDefault(); go(cur - 1); }
  });
  dlg.addEventListener('close', function () {
    unlockScroll();
    history.replaceState(null, '', location.pathname + location.search);
    if (opener) opener.focus();
  });
  var h = location.hash.slice(1);
  if (RECIPES[h]) open(h);
})();
